import { SeasonTrades } from "../../schemas/Trade";
import { manager } from "../stringConstants";

export const michaelTrades: SeasonTrades[] = [
  {
    season: "2011/12",
    allTrades: [
      {
        otherTeam: manager.sagi,
        sentAway: "Chris Bosh, Marc Gasol and Mike Conley",
        gotInReturn: "Al Jefferson and Demarcus Cousins",
        amongBestTrades: true
      },
    ],
  },
  {
    season: "2013/14",
    allTrades: [
      {
        otherTeam: manager.chauncey,
        sentAway: "Deron Williams, Al Jefferson, David Lee and Jeremy Lamb",
        gotInReturn:
          "Jeff Teague, Derrick Favors, Ryan Anderson, John Henson and Jared Sullinger",
      },
    ],
  },
];
